<template>
  <div>
    <b-card title="Addition">
      <b-card-body>
        <table class="arith-table">
          <tr>
            <td colspan="2"> &nbsp; </td>
            <td colspan="2" align="right"><b-form-select v-model="additionBase" :options="bases"/></td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              A =
            </td>
            <td class="arith-input">
              <u-input-number v-model="a" decimal binary hexadecimal/>
            </td>
            <td class="arith-equals"> &nbsp; </td>
            <td class="arith-numbers">
              {{convertedA}}
            </td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              B =
            </td>
            <td class="arith-input">
              <u-input-number v-model="b" decimal binary hexadecimal/>
            </td>
            <td class="arith-equals arith-bottom"> &plus; </td>
            <td class="arith-numbers arith-bottom">
              {{convertedB}}
            </td>
          </tr>
          <tr>
            <td colspan="4" class="arith-numbers">{{sum}}</td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card title="Subtraction">
      <b-card-body>
        <table class="arith-table">
          <tr>
            <td colspan="2"> &nbsp; </td>
            <td colspan="2"><b-form-select v-model="subtractionBase" :options="bases"/></td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              C =
            </td>
            <td class="arith-input">
              <u-input-number v-model="c" decimal binary hexadecimal/>
            </td>
            <td class="arith-equals"> &nbsp; </td>
            <td class="arith-numbers">
              {{convertedC}}
            </td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              D =
            </td>
            <td class="arith-input">
              <u-input-number v-model="d" decimal binary hexadecimal/>
            </td>
            <td class="arith-equals arith-bottom"> &minus; </td>
            <td class="arith-numbers arith-bottom">
              {{convertedD}}
            </td>
          </tr>
          <tr>
            <td colspan="4" class="arith-numbers">{{difference}}</td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card title="Multiplication">
      <b-card-body>
        <table class="arith-table">
          <tr>
            <td align="right" class="arith-variables">
              E =
            </td>
            <td class="arith-input">
              <u-input-number v-model="e" decimal binary hexadecimal/>
            </td>
            <td><b-button pill variant="outline-primary" @click="updateProduct"> &times; </b-button></td>
            <td class="arith-numbers"> {{multiplicationBase}} </td>
            <td class="arith-numbers"> &equals; </td>
            <td class="arith-numbers">{{convertedProduct}}</td>
          </tr>
        </table>
      </b-card-body>

    </b-card><p/>
  </div>
</template>

<script>
import {Numbers} from '@/util/numbers'
import UcrDrkInputNumber from '@/components/ucrdrk-input-number'

export default {
  name: 'Arithmetic',
  data () {
    return {
      a: {value: 0, base: 2},
      b: {value: 0, base: 2},
      c: {value: 0, base: 2},
      d: {value: 0, base: 2},
      e: {value: 0, base: 2},
      additionBase: 2,
      subtractionBase: 2,
      multiplicationBase: 2,
      currentProduct: 0,
      bases: [
        {value: 2, text: 'Binary'},
        {value: 10, text: 'Decimal'},
        {value: 16, text: 'Hexadecimal'}
      ]
    }
  },
  mixins: [Numbers],
  components: {
    'u-input-number': UcrDrkInputNumber
  },
  computed: {
    sum: function () {
      return this.convert(this.a.value + this.b.value, this.additionBase)
    },
    difference: function () {
      return this.convert(this.c.value - this.d.value, this.subtractionBase)
    },
    product: function () {
      return this.convert(this.currentProduct, this.multiplicationBase)
    },
    convertedA: function () {
      return this.convert(this.a.value, this.additionBase)
    },
    convertedB: function () {
      return this.convert(this.b.value, this.additionBase)
    },
    convertedC: function () {
      return this.convert(this.c.value, this.subtractionBase)
    },
    convertedD: function () {
      return this.convert(this.d.value, this.subtractionBase)
    },
    convertedProduct: function () {
      return this.convert(this.currentProduct, this.multiplicationBase)
    }
  },
  methods: {
    convert: function (value, base) {
      switch (base) {
        case 2:
          return this.toBinary(value)
        case 10:
          return this.toDecimal(value)
        case 16:
          return this.toHexadecimal(value)
        default:
          return ''
      }
    },
    updateProduct: function () {
      this.currentProduct *= this.multiplicationBase
    }
  },
  watch: {
    e: function () {
      this.multiplicationBase = this.e.base
      this.currentProduct = this.e.value
    }
  }
}
</script>

<style scoped>
.arith-numbers {
  font-family: monospace;
  font-size: x-large;
  text-align: right;
}

.arith-variables {
  width: 50px;
  min-width: 50px;
  max-width: 50px;

}

.arith-input {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.arith-equals {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  text-align: center;
}

.arith-table {
  width: 425px;
  max-width: 425px;
  min-width: 425px;
}

.arith-bottom {
  border-bottom: 1pt solid black;
}

th, td {
  padding-right: 12px;
  padding-bottom: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/arithmetic.vue